module.exports = "/_next/static/images/chrome-icon-2748bc0474da53f8aa3a4bedce3c58ce.png";